const caseGeneratorSwedish = {
  header: {
    title: "Case Inlägg Generator",
    description: "Låt AI hjälpa dig att skapa ett engagerande LinkedIn-inlägg baserat på ditt case"
  },
  customerBanner: {
    working: "Du genererar nu ett case-inlägg för"
  },
  input: {
    title: "Beskriv ditt case",
    placeholder: "Berätta om ditt case eller din historia. Det kan vara ett kundcase, ett intressant möte, eller en annan upplevelse du vill dela på LinkedIn..."
  },
  image: {
    title: "Vill du lägga till en bild?",
    gallery: "Välj från bildarkiv",
    upload: "Ladda upp bild",
    camera: "Ta foto",
    remove: "Ta bort bild"
  },
  buttons: {
    generate: "Generera inlägg från case",
    generating: "Genererar inlägg...",
    retry: "Försök igen",
    edit: "Redigera",
    remove: "Ta bort bild",
    addImage: "Bild",
    save: "Spara ändringar",
    saving: "Sparar",
    cancel: "Avbryt",
    accept: "Acceptera",
    fortryd: "Kassera",
    scheduling: "Planerar...",
    schedulePost: "Schemalägg inlägg"
  },
  aiPrompt: {
    placeholder: "Beskriv hur case-inlägget ska förbättras...",
    editing: "Redigerar",
    send: "Skicka"
  },
  loading: {
    generating: "Genererar ett LinkedIn-inlägg baserat på ditt case..."
  },
  messages: {
    error: "Ett fel uppstod vid generering av case-inlägg. Försök igen senare.",
    draftLoaded: "Ditt senaste case-utkast har laddats",
    fieldRequired: "Vänligen ange en case-beskrivning för att generera ett inlägg",
    imageAdded: "Bild tillagd!",
    imageRemoved: "Bild borttagen!",
    caseGenerated: "Case-inlägg genererat!",
    savedChanges: "Ändringar sparade!",
    caseUpdated: "Case-inlägg uppdaterat!",
    imageUploaded: "Bild uppladdad och tillagd!",
    caseScheduled: "Case-inlägg schemalagt till {formattedDate}",
    aiSelectedTime: "AI har valt den optimala tiden!",
    confirmDiscard: "Är du säker på att du vill kassera detta inlägg? Alla ändringar kommer att gå förlorade.",
    caseRegenerated: "Case-inlägg regenererat!"
  },
  gallery: {
    title: "Välj en bild",
    noImages: "Du har inga bilder i ditt arkiv.",
    goToArchive: "Gå till bildarkiv"
  },
  weekCalendar: {
    selectDay: "Välj dag för ditt inlägg",
    selectTime: "Välj tid för {day}",
    addPost: "Lägg till inlägg",
    backToDays: "Tillbaka till dagar",
    schedulerNote: "Dessa tider är konfigurerade i din Schemaläggare men inte ännu upptagna av befintliga inlägg."
  },
  saveModal: {
    title: "Schemalägg ditt case-inlägg",
    question: "Hur vill du schemalägga ditt case-inlägg?",
    options: {
      weekly: {
        title: "Använd mitt veckoschema",
        description: "Inlägget kommer att delas enligt din normala schemaläggning"
      },
      custom: {
        title: "Välj egen tidpunkt",
        description: "Välj exakt när inlägget ska delas"
      },
      ai: {
        title: "Låt AI schemalägga",
        description: "AI väljer den optimala tidpunkten baserat på LinkedIn-statistik"
      }
    },
    weekly: {
      confirm: "Ditt inlägg kommer att läggas till din normala schemaläggning och delas enligt din veckoplan."
    },
    custom: {
      title: "Välj datum och tid för ditt inlägg:"
    },
    buttons: {
      back: "Tillbaka",
      confirm: "Bekräfta",
      saving: "Sparar..."
    },
    success: {
      weekly: "Ditt case-inlägg har sparats och schemalagts för delning på LinkedIn!",
      custom: "Ditt case-inlägg har schemalagts för delning på LinkedIn {date}!",
      ai: "Ditt case-inlägg har schemalagts för delning på LinkedIn {date}!"
    }
  }
};

export default caseGeneratorSwedish; 